
export default {
    searchLandings(params) {
        let path = process.env.apiPath + '/publisher/landings.search';
        params = params || {};
        if (!params.page) {
            params.page = 1;
        }
        return this.makeRequest(path, params);
    },

    saveLanding(params) {
        let path = process.env.apiPath + '/publisher/landings.create';
        params = params || {};
        return this.makeRequest(path, params);
    },

    getOfferLinks(params) {
        let path = process.env.apiPath + '/publisher/links.search';
        params = params || {};
        params.fields = 'link.url,link.offer,link.default,link.selfie_link,link.locales,offer.advertiser,offer.locales,link.image,link.thumbnail';
        return this.makeRequest(path, params);
    }
};
